import React from "react";
import "./Contact.css";
import EmailForm from "./EmailForm";
import Toastr from "toastr";
import * as PropTypes from "prop-types";

class Contact extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      person: {
        name: "",
        email: "",
        phone: "",
        address: "",
        subject: "",
        message: ""
      },
      saved: false
    };
  }

  static contextTypes = {
    router: PropTypes.object
  };

  onChange = e => {
    const field = e.target.name;
    const person = this.state.person;
    person[field] = e.target.value;
    this.setState({ person });
  };

  onSave = e => {
    e.preventDefault();
    this.setState({ saving: true });
    const url = "https://formspree.io/elmuhandisauto@gmail.com";
    let vaildPerson = false;
    const { name, message, phone } = this.state.person;
    if (name === "" || message === "" || phone === "") {
      vaildPerson = false;
    } else {
      vaildPerson = true;
    }

    fetch(url, {
      method: "POST",
      headers: {
        "Content-type": "application/json"
      },
      body: JSON.stringify(this.state.person)
    })
      .then(
        res => {
          if (res.ok && vaildPerson) {
            return res.json();
          }
          throw new Error("Request failed");
        },
        err => {
          Toastr.error("حدث خطأ ما برجاء مراجعة بياناتك مرة اخرى");
        }
      )
      .then(data => this.redirect())
      .catch(err => {
        Toastr.error("حدث خطأ ما برجاء مراجعة بياناتك مرة اخرى");
        this.setState({ saving: true });
      });
  };

  redirect = () => {
    Toastr.success("تم الإرسال بنجاح");
    this.setState({ saving: true });
    this.context.router.history.push("/");
  };

  render() {
    const { saving, person } = this.state;
    return (
      <div id="contact" className="wrapper">
        <EmailForm
          saving={saving}
          person={person}
          onChange={this.onChange}
          onSave={this.onSave}
        />
        <div className="cairo-font">
          <h2>الهواتف</h2>
          <h3>{" " + 224727794} :المركز</h3>
          <h3>مهندس/موسى</h3>
          <p>01222811311</p>
          <h3>مهندس/ابراهيم</h3>
          <p>01115136318</p>
          <p>01065246803</p>
        </div>
      </div>
    );
  }
}
export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact/Contact.js